var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',_vm._g(_vm._b({attrs:{"inset":""}},'v-switch',_vm.computedProps,false),_vm.computedListeners))}
var staticRenderFns = []

export { render, staticRenderFns }